export const setOptions = (data) => {
  return (dispatch) => dispatch({ type: 'SET_OPTIONS', data: data });
};

export const toggleCustomerView = (data) => {
  return (dispatch) => dispatch({ type: 'TOGGLE_CUSTOMER_VIEW', data: data });
};
